/**
 * Binary on/off switch — drop-in replacement for a Yes/No checkbox. Coffman
 * blue track when ON, neutral gray when OFF, white sliding knob. Controlled:
 * pass `value` + `onChange`. Renders as a real <button role="switch"> so it's
 * keyboard- and screen-reader-accessible for free.
 */
interface ToggleProps {
  value: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
}

export function Toggle({
  value,
  onChange,
  disabled = false,
  id,
  'aria-label': ariaLabel,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={value}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!value)}
      style={{
        position: 'relative',
        width: 38,
        height: 22,
        flexShrink: 0,
        borderRadius: 999,
        border: 'none',
        padding: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        background: value ? 'var(--accent)' : '#c4c8d0',
        opacity: disabled ? 0.5 : 1,
        transition: 'background 140ms ease',
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: 2,
          left: value ? 18 : 2,
          width: 18,
          height: 18,
          borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
          transition: 'left 140ms ease',
        }}
      />
    </button>
  );
}
